var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#994636",
    d: "M 374.003906 186.003906 C 374.003906 289.246094 290.242188 373.003906 187 373.003906 C 83.761719 373.003906 0 289.246094 0 186.003906 C 0 82.765625 83.761719 -0.996094 187 -0.996094 C 290.242188 -0.996094 374.003906 82.765625 374.003906 186.003906 Z M 14.960938 186.003906 C 14.960938 280.984375 92.019531 358.046875 187 358.046875 C 281.980469 358.046875 359.042969 280.984375 359.042969 186.003906 C 359.042969 91.023438 281.980469 13.960938 187 13.960938 C 92.019531 13.960938 14.960938 91.023438 14.960938 186.003906 Z M 82.28125 193.484375 C 78.152344 193.484375 74.800781 190.132812 74.800781 186.003906 C 74.800781 181.875 78.152344 178.523438 82.28125 178.523438 L 291.722656 178.523438 C 295.851562 178.523438 299.203125 181.875 299.203125 186.003906 C 299.203125 190.132812 295.851562 193.484375 291.722656 193.484375 Z M 82.28125 193.484375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.67de0a8a82b5d3dccdec064b4cc33e48.svg";
export { ForwardRef as ReactComponent };